import { handleActions } from 'redux-actions-helpers'
import { CriteriaItemType, InitialState } from './types'
import * as actions from './actions'

const initialState: InitialState = {
  work: null,
  meta: null,
  criteries: [],
  isFetchingWork: false,
  isFetchingCriteries: false,
  isProcessSendReview: false,
  error: '',
}

export default handleActions(
  {
    [actions.fetchRandomWork]: state => {
      return {
        ...state,
        isFetchingWork: true,
        error: initialState.error,
      }
    },
    [actions.fetchRandomWorkSuccess]: (state, action) => {
      return {
        ...state,
        work: Array.isArray(action.result.data) ? null : action.result.data,
        meta: action.result.meta,
        isFetchingWork: false,
      }
    },
    [actions.fetchRandomWorkFailure]: (state, action) => {
      return {
        ...state,
        isFetchingWork: false,
        error: action.error,
      }
    },
    [actions.fetchCriteries]: state => {
      return {
        ...state,
        criteries: initialState.criteries,
        isFetchingCriteries: true,
        error: initialState.error,
      }
    },
    [actions.fetchCriteriesSuccess]: (state, action) => {
      return {
        ...state,
        criteries: action.result.map((item: CriteriaItemType) => {
          return {
            ...item,
            value: 0,
          }
        }),
        isFetchingCriteries: false,
      }
    },
    [actions.fetchCriteriesFailure]: (state, action) => {
      return {
        ...state,
        isFetchingCriteries: false,
        error: action.error,
      }
    },
    [actions.setCriteriaParam]: (state, action) => {
      const criteries = [...state.criteries].map(item => {
        if (item.criterion_id === action.criterion_id) {
          return {
            ...item,
            [action.name]: action.value,
          }
        }
        return item
      })
      return {
        ...state,
        criteries,
      }
    },
    [actions.fetchWork]: state => {
      return {
        ...state,
        isFetchingWork: true,
        error: initialState.error,
      }
    },
    [actions.fetchWorkSuccess]: (state, action) => {
      return {
        ...state,
        work: action.result.data,
        meta: action.result.meta,
        isFetchingWork: false,
      }
    },
    [actions.fetchWorkFailure]: (state, action) => {
      return {
        ...state,
        isFetchingWork: false,
        error: action.error,
      }
    },
    [actions.sendWorkReview]: state => {
      return {
        ...state,
        isProcessSendReview: true,
        error: initialState.error,
      }
    },
    [actions.sendWorkReviewSuccess]: (state, action) => {
      return {
        ...state,
        work: action.result.data,
        meta: action.result.meta,
        isProcessSendReview: false,
      }
    },
    [actions.sendWorkReviewFailure]: (state, action) => {
      return {
        ...state,
        isProcessSendReview: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
